
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34450',
  depVersions: {
  "documents-public-ui": "static-1.34450",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34455",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2114",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5575",
  "hs-test-utils": "static-1.7994",
  "hub-http": "static-1.6202",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11448",
  "I18n": "static-7.1617",
  "jasmine-immutable": "static-1.3001",
  "jasmine-runner": "static-1.6446",
  "lodash": "static-1.3",
  "quartz": "static-1.7000",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16647",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.97",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4747",
  "webpack-env": "static-1.54",
  "atom": "static-1.5051",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2477",
  "classnames": "static-2.10",
  "cssUtils": "static-1.786",
  "customer-data-filters-ui": "static-1.39675",
  "customer-data-objects": "static-1.7643",
  "customer-data-property-utils": "static-1.8067",
  "data-fetching-client": "static-1.9650",
  "enviro": "static-4.446",
  "FireAlarmUi": "static-1.4496",
  "flux-actions": "static-1.333",
  "FormsCommonComponents": "static-1.85775",
  "FormUrlGenerator": "static-2.4698",
  "foundations-components": "static-1.7891",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11755",
  "icons": "static-2.644",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7138",
  "metrics-js": "static-1.9619",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.397",
  "property-description-translator": "static-1.3825",
  "property-translator": "static-1.5380",
  "quartz-config": "static-1.778",
  "quartz-core": "static-1.6219",
  "quick-fetch": "static-1.3898",
  "raven": "static-3.5907",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5326",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8149",
  "reference-resolvers-lite": "static-1.8074",
  "report-customization-components": "static-1.13094",
  "reporting-enablement": "static-1.22836",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.97",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4631",
  "sales-content-partitioning": "static-1.8920",
  "SalesContentIndexUI": "static-3.9209",
  "sanitize": "static-1.4457",
  "sanitize-text": "static-1.8122",
  "self-service-api": "static-1.10228",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1728",
  "signup-constants": "static-1.18803",
  "signup-ui-lego-core": "static-1.20813",
  "signup-ui-url-generator": "static-2.8023",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4743",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10972",
  "ui-addon-i18n": "static-1.11131",
  "ui-addon-react-router-dom": "static-1.9524",
  "ui-addon-upgrades": "static-9.17953",
  "ui-asset-management-lib": "static-1.10994",
  "ui-images": "static-2.1147",
  "UIComponents": "static-3.8394",
  "usage-tracker": "static-1.7324",
  "usage-tracker-container": "static-1.7314",
  "usage-tracker-core": "static-1.7174",
  "usage-tracker-public": "static-1.7135",
  "viral-links-lib": "static-1.7037",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3385",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3277",
  "quartz-webpack": "static-1.3224",
  "ai-components-ui-library": "static-1.8876",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4844",
  "foundations-theming": "static-1.4398",
  "quartz-auth": "static-1.675",
  "ui-business-units-lib": "static-1.9029",
  "usage-tracker-session-replay": "static-1.5010",
  "foundations-theming-base": "static-1.3383",
  "HeadJS": "static-2.754",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3105",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.67",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4307",
  "csstype": "static-1.50",
  "quartz-head": "static-1.665",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7908",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3572",
  "persist-promise": "static-1.3677",
  "quartz-i18n": "static-1.675",
  "reporting-client-types": "static-1.2496",
  "foundations-components-legacy": "static-1.916",
  "hs-story-utils": "static-1.9407",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9907",
  "hubspotter-http": "static-1.4635",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.195",
  "conversations-skeleton-state": "static-1.7227",
  "crm-message-bus": "static-1.42927",
  "customer-data-filters-ui-msw-helpers": "static-1.22110",
  "customer-data-objects-ui-components": "static-1.13004",
  "customer-data-reference-ui-components": "static-1.13140",
  "customer-data-ui-utilities": "static-1.9806",
  "framework-builder-read-service-client": "static-1.3991",
  "framework-data-schema-quick-fetch": "static-1.6767",
  "framework-data-schema-resolvers": "static-1.6862",
  "inbound-db-properties-service-client": "static-1.3829",
  "multi-account-reference-resolvers": "static-1.957",
  "onboarding-tours": "static-1.16554",
  "reporting-datasets-permissions-lib": "static-1.13613",
  "ui-addon-teams": "static-1.21514",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68290",
  "customer-data-properties": "static-1.51458",
  "forms-ai-lib": "static-1.4284",
  "forms-utils-lib": "static-1.12533",
  "foundations-components-test-utils": "static-1.5374",
  "react-dnd-compat": "static-1.4599",
  "react-tinymce": "static-1.55174",
  "tinymce-config": "static-2.54300",
  "ui-gdpr-components": "static-1.10326",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4160",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1811",
  "ui-fonts": "static-1.710",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "mobile-manifest-mixins": "static-1.529",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.430",
  "quartz-test": "static-1.675",
  "quartz-tracking": "static-1.379",
  "batch-promise": "static-1.1520",
  "external-options-client-types": "static-1.4140",
  "react-colorpicker": "static-2.10190",
  "ui-addon-draggable-compat": "static-2.4235",
  "copilot-toolkit": "static-1.11074",
  "data-quality-ui-library": "static-1.12937",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6441",
  "reporting-action-components": "static-1.41239",
  "reporting-filters": "static-1.277",
  "reporting-insights-lib": "static-1.1668",
  "reporting-plugins": "static-1.10287",
  "ui-addon-opt": "static-4.8351",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25305",
  "hubspot-apollo-client": "static-1.4857",
  "bend-plugin-chirp-manifest": "static-1.41",
  "chirp-fetch": "static-1.1867",
  "sales-templates-service-types-lib": "static-1.4153",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5846",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4063",
  "nested-table": "static-1.206",
  "timezone-utils": "static-2.5224",
  "bender-build-tools": "static-1.3171",
  "chatspot-core": "static-1.21175",
  "bend-plugin-foundations-theming": "static-1.2881",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9905",
  "hs-resources": "static-1.133",
  "pulse": "static-1.552",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3779",
  "crm-pipelines-api-client-types": "static-1.4124",
  "multi-currency-client-types": "static-1.3674",
  "getting-started-shared-tasks": "static-1.18437",
  "growth-data-modal": "static-1.5393",
  "growth-onboarding-confetti": "static-1.3046",
  "growth-onboarding-next-action-utils": "static-1.1852",
  "navigation-components": "static-1.17964",
  "onboarding-tours-client": "static-1.4768",
  "onboarding-tours-utils": "static-1.620",
  "ui-shepherd-react": "static-3.10137",
  "ui-shepherd-tracker": "static-1.7518",
  "ui-universal-auth": "static-1.8952",
  "user-context": "static-1.5082",
  "cms-field-types": "static-1.4791",
  "content-icons-ui": "static-1.2220",
  "integrations-lib": "static-1.16037",
  "calling-global-api": "static-1.64431",
  "calling-internal-common": "static-1.31281",
  "calling-lifecycle-internal": "static-1.65813",
  "calling-lifecycle-messages": "static-1.58107",
  "commerce-products-lib": "static-1.9470",
  "crm-links": "static-1.6265",
  "customer-data-properties-shared-msw-handlers": "static-1.9234",
  "file-manager-components": "static-1.23553",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4205",
  "meetings-icalendar-utils-lib": "static-1.611",
  "object-builder-ui-client": "static-1.48654",
  "pipeline-validation-client-types": "static-1.3948",
  "property-value-citations": "static-1.2072",
  "smart-property-lib": "static-1.6814",
  "tiered-pricing": "static-1.1149",
  "ui-addon-iframeable": "static-1.9036",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19788",
  "tinymce-themes": "static-1.56270",
  "data-token-picker": "static-1.16366",
  "hub-http-contrib": "static-1.3022",
  "interframe": "static-3.4740",
  "tinymce-data": "static-1.40385",
  "tinymce-plugins": "static-1.57414",
  "ui-addon-sales-email": "static-1.5191",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5539",
  "magpie-types": "static-1.4999",
  "simple-logging-lib": "static-1.3028",
  "content-assistance-lib": "static-1.7716",
  "dashboard-lib": "static-1.81426",
  "ExportDialog": "static-6.10371",
  "hubspot-prosemirror": "static-1.18177",
  "hubspot-prosemirror-plugins": "static-1.18169",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8683",
  "campaign-roi-lib": "static-1.9016",
  "feedback-loader": "static-1.29252",
  "apollo-link-hub-http": "static-2.4630",
  "hubspot-apollo-cache": "static-1.316",
  "purchase-motions-api": "static-1.5849",
  "trials-service-types": "static-1.3882",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.153",
  "markdown-it": "static-1.6",
  "bend-plugin-pulse": "static-1.55",
  "directed-graph": "static-1.914",
  "event-emitter": "static-1.928",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1921",
  "growth-onboarding-next-action-components": "static-1.1880",
  "user-context-client": "static-1.4592",
  "idb-keyval": "static-1.43",
  "nest": "static-1.205",
  "reactive-lib": "static-1.702",
  "unified-auth-core-lib": "static-1.748",
  "getting-started-shared-tasks-store": "static-1.17555",
  "integrations-error-boundary-lib": "static-1.13452",
  "integrations-tracking-lib": "static-1.5579",
  "native-integrations-shared-strings": "static-1.7762",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10349",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.466",
  "calling-error-reporting": "static-1.31288",
  "shared-worker-versioning": "static-1.11017",
  "calling-usage-tracker": "static-1.6522",
  "voice-sms-access-library": "static-1.893",
  "customer-data-tracking": "static-1.6868",
  "commerce-permissions": "static-1.747",
  "products-iframe-lib": "static-1.7867",
  "products-ui-components-shared-msw-handlers": "static-1.10289",
  "location-customization-utils-lib": "static-1.9178",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4133",
  "video-components-external": "static-1.11191",
  "video-data-lib": "static-1.34849",
  "data-agent-kit": "static-1.158",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9990",
  "fsm": "static-1.3712",
  "policy-lib": "static-1.6758",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10053",
  "navigation-messaging": "static-1.7291",
  "FileManagerLib": "static-1.39193",
  "NamespacedHubStyle": "static-2.9041",
  "FileManagerCore": "static-1.39052",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12402",
  "layout-dnd-utils": "static-1.11377",
  "react-codemirror": "static-1.10605",
  "ui-addon-emoji-picker": "static-1.9868",
  "ui-brand-identity-lib": "static-1.15178",
  "ui-addon-video-player": "static-1.8683",
  "ui-coaching-tips": "static-1.28484",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23467",
  "EmailSignatureEditor": "static-1.24317",
  "breeze-engine-lib": "static-1.547",
  "InboxConnectUtils": "static-4.14749",
  "universal-page-editor-lib": "static-1.2993",
  "google-sheets-integration-lib": "static-1.166",
  "microsoft-drive-integration-lib": "static-1.281",
  "calling-orchestration-schema": "static-1.35670",
  "sales-views-client-types": "static-1.4244",
  "crm-record-cards-service-types": "static-1.3587",
  "content-media-composition-data-lib": "static-1.12177",
  "content-media-compositions": "static-2.16184",
  "media-bridge-lib": "static-1.18884",
  "trellis-story-utils": "static-1.4495",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5881",
  "FileManagerImages": "static-1.36704",
  "video-components": "static-1.13194",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4516",
  "video-embed": "static-1.35683",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68365",
  "layout-data-lib": "static-1.9702",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6561",
  "commerce-tours-lib": "static-1.6050",
  "growth-onboarding-reliability": "static-1.5063",
  "sales-checkout-service-client": "static-1.3619",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21632",
  "sales-email-signature-service-client": "static-1.3822",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22017",
  "outpost": "static-1.4165",
  "advanced-menus-core": "static-1.15094",
  "advanced-menus-lib": "static-1.12038",
  "ui-memberships-settings-lib": "static-1.33980",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15093",
  "simple-menus-lib": "static-1.16610"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34450",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34455",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2114",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5575",
  "hs-test-utils": "/hs-test-utils/static-1.7994",
  "hub-http": "/hub-http/static-1.6202",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11448",
  "I18n": "/I18n/static-7.1617",
  "jasmine-immutable": "/jasmine-immutable/static-1.3001",
  "jasmine-runner": "/jasmine-runner/static-1.6446",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.7000",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16647",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.97",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4747",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5051",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2477",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.786",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39675",
  "customer-data-objects": "/customer-data-objects/static-1.7643",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8067",
  "data-fetching-client": "/data-fetching-client/static-1.9650",
  "enviro": "/enviro/static-4.446",
  "FireAlarmUi": "/FireAlarmUi/static-1.4496",
  "flux-actions": "/flux-actions/static-1.333",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85775",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4698",
  "foundations-components": "/foundations-components/static-1.7891",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11755",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7138",
  "metrics-js": "/metrics-js/static-1.9619",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "property-description-translator": "/property-description-translator/static-1.3825",
  "property-translator": "/property-translator/static-1.5380",
  "quartz-config": "/quartz-config/static-1.778",
  "quartz-core": "/quartz-core/static-1.6219",
  "quick-fetch": "/quick-fetch/static-1.3898",
  "raven": "/raven/static-3.5907",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5326",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8149",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8074",
  "report-customization-components": "/report-customization-components/static-1.13094",
  "reporting-enablement": "/reporting-enablement/static-1.22836",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.97",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.97",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4631",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8920",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9209",
  "sanitize": "/sanitize/static-1.4457",
  "sanitize-text": "/sanitize-text/static-1.8122",
  "self-service-api": "/self-service-api/static-1.10228",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1728",
  "signup-constants": "/signup-constants/static-1.18803",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20813",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8023",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4743",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10972",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11131",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9524",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17953",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10994",
  "ui-images": "/ui-images/static-2.1147",
  "UIComponents": "/UIComponents/static-3.8394",
  "usage-tracker": "/usage-tracker/static-1.7324",
  "usage-tracker-container": "/usage-tracker-container/static-1.7314",
  "usage-tracker-core": "/usage-tracker-core/static-1.7174",
  "usage-tracker-public": "/usage-tracker-public/static-1.7135",
  "viral-links-lib": "/viral-links-lib/static-1.7037",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3385",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3277",
  "quartz-webpack": "/quartz-webpack/static-1.3224",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8876",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4844",
  "foundations-theming": "/foundations-theming/static-1.4398",
  "quartz-auth": "/quartz-auth/static-1.675",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9029",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5010",
  "foundations-theming-base": "/foundations-theming-base/static-1.3383",
  "HeadJS": "/HeadJS/static-2.754",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3105",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.67",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4307",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.665",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7908",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3572",
  "persist-promise": "/persist-promise/static-1.3677",
  "quartz-i18n": "/quartz-i18n/static-1.675",
  "reporting-client-types": "/reporting-client-types/static-1.2496",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.916",
  "hs-story-utils": "/hs-story-utils/static-1.9407",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9907",
  "hubspotter-http": "/hubspotter-http/static-1.4635",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.195",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7227",
  "crm-message-bus": "/crm-message-bus/static-1.42927",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22110",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13004",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13140",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9806",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3991",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6767",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6862",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3829",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.957",
  "onboarding-tours": "/onboarding-tours/static-1.16554",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13613",
  "ui-addon-teams": "/ui-addon-teams/static-1.21514",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68290",
  "customer-data-properties": "/customer-data-properties/static-1.51458",
  "forms-ai-lib": "/forms-ai-lib/static-1.4284",
  "forms-utils-lib": "/forms-utils-lib/static-1.12533",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5374",
  "react-dnd-compat": "/react-dnd-compat/static-1.4599",
  "react-tinymce": "/react-tinymce/static-1.55174",
  "tinymce-config": "/tinymce-config/static-2.54300",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10326",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4160",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1811",
  "ui-fonts": "/ui-fonts/static-1.710",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.529",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.430",
  "quartz-test": "/quartz-test/static-1.675",
  "quartz-tracking": "/quartz-tracking/static-1.379",
  "batch-promise": "/batch-promise/static-1.1520",
  "external-options-client-types": "/external-options-client-types/static-1.4140",
  "react-colorpicker": "/react-colorpicker/static-2.10190",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4235",
  "copilot-toolkit": "/copilot-toolkit/static-1.11074",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12937",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6441",
  "reporting-action-components": "/reporting-action-components/static-1.41239",
  "reporting-filters": "/reporting-filters/static-1.277",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1668",
  "reporting-plugins": "/reporting-plugins/static-1.10287",
  "ui-addon-opt": "/ui-addon-opt/static-4.8351",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25305",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4857",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.41",
  "chirp-fetch": "/chirp-fetch/static-1.1867",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4153",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5846",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4063",
  "nested-table": "/nested-table/static-1.206",
  "timezone-utils": "/timezone-utils/static-2.5224",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "chatspot-core": "/chatspot-core/static-1.21175",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2881",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9905",
  "hs-resources": "/hs-resources/static-1.133",
  "pulse": "/pulse/static-1.552",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3779",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4124",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3674",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18437",
  "growth-data-modal": "/growth-data-modal/static-1.5393",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3046",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1852",
  "navigation-components": "/navigation-components/static-1.17964",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4768",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.620",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10137",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7518",
  "ui-universal-auth": "/ui-universal-auth/static-1.8952",
  "user-context": "/user-context/static-1.5082",
  "cms-field-types": "/cms-field-types/static-1.4791",
  "content-icons-ui": "/content-icons-ui/static-1.2220",
  "integrations-lib": "/integrations-lib/static-1.16037",
  "calling-global-api": "/calling-global-api/static-1.64431",
  "calling-internal-common": "/calling-internal-common/static-1.31281",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65813",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58107",
  "commerce-products-lib": "/commerce-products-lib/static-1.9470",
  "crm-links": "/crm-links/static-1.6265",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9234",
  "file-manager-components": "/file-manager-components/static-1.23553",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4205",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.611",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48654",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3948",
  "property-value-citations": "/property-value-citations/static-1.2072",
  "smart-property-lib": "/smart-property-lib/static-1.6814",
  "tiered-pricing": "/tiered-pricing/static-1.1149",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9036",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19788",
  "tinymce-themes": "/tinymce-themes/static-1.56270",
  "data-token-picker": "/data-token-picker/static-1.16366",
  "hub-http-contrib": "/hub-http-contrib/static-1.3022",
  "interframe": "/interframe/static-3.4740",
  "tinymce-data": "/tinymce-data/static-1.40385",
  "tinymce-plugins": "/tinymce-plugins/static-1.57414",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5191",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5539",
  "magpie-types": "/magpie-types/static-1.4999",
  "simple-logging-lib": "/simple-logging-lib/static-1.3028",
  "content-assistance-lib": "/content-assistance-lib/static-1.7716",
  "dashboard-lib": "/dashboard-lib/static-1.81426",
  "ExportDialog": "/ExportDialog/static-6.10371",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18177",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18169",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8683",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9016",
  "feedback-loader": "/feedback-loader/static-1.29252",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4630",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.316",
  "purchase-motions-api": "/purchase-motions-api/static-1.5849",
  "trials-service-types": "/trials-service-types/static-1.3882",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.153",
  "markdown-it": "/markdown-it/static-1.6",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.55",
  "directed-graph": "/directed-graph/static-1.914",
  "event-emitter": "/event-emitter/static-1.928",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1921",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1880",
  "user-context-client": "/user-context-client/static-1.4592",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.205",
  "reactive-lib": "/reactive-lib/static-1.702",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.748",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17555",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13452",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5579",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7762",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10349",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.466",
  "calling-error-reporting": "/calling-error-reporting/static-1.31288",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11017",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6522",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.893",
  "customer-data-tracking": "/customer-data-tracking/static-1.6868",
  "commerce-permissions": "/commerce-permissions/static-1.747",
  "products-iframe-lib": "/products-iframe-lib/static-1.7867",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10289",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9178",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4133",
  "video-components-external": "/video-components-external/static-1.11191",
  "video-data-lib": "/video-data-lib/static-1.34849",
  "data-agent-kit": "/data-agent-kit/static-1.158",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9990",
  "fsm": "/fsm/static-1.3712",
  "policy-lib": "/policy-lib/static-1.6758",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10053",
  "navigation-messaging": "/navigation-messaging/static-1.7291",
  "FileManagerLib": "/FileManagerLib/static-1.39193",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9041",
  "FileManagerCore": "/FileManagerCore/static-1.39052",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12402",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11377",
  "react-codemirror": "/react-codemirror/static-1.10605",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9868",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15178",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8683",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28484",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23467",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24317",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.547",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14749",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2993",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.166",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.281",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35670",
  "sales-views-client-types": "/sales-views-client-types/static-1.4244",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12177",
  "content-media-compositions": "/content-media-compositions/static-2.16184",
  "media-bridge-lib": "/media-bridge-lib/static-1.18884",
  "trellis-story-utils": "/trellis-story-utils/static-1.4495",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5881",
  "FileManagerImages": "/FileManagerImages/static-1.36704",
  "video-components": "/video-components/static-1.13194",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4516",
  "video-embed": "/video-embed/static-1.35683",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68365",
  "layout-data-lib": "/layout-data-lib/static-1.9702",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6561",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6050",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5063",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3619",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21632",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3822",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22017",
  "outpost": "/outpost/static-1.4165",
  "advanced-menus-core": "/advanced-menus-core/static-1.15094",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12038",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33980",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15093",
  "simple-menus-lib": "/simple-menus-lib/static-1.16610"
}
};
